import React from 'react';
import InsightsCard from '../InsightCards/insightcards';
import Filters from '../Filters/filters';

const LeftPanel = () => {
  return (
    <div className="left-panel">
        <Filters />
      <InsightsCard 
        icon="🔥" 
        text="Wildfire risk rising in California by 16%" 
        color="#ff6b6b" 
      />
      <InsightsCard 
        icon="💧" 
        text="Flood-prone areas in Bangladesh increased in last 5 years" 
        color="#3498db" 
      />
      <InsightsCard 
        icon="🌫️" 
        text="High pollution levels detected in Eastern Europe" 
        color="#95a5a6" 
      />
      
    </div>
  );
};

export default LeftPanel;
